import { articles } from './articles/articles';
import { authors } from './authors/authors';
import { pages } from './pages/pages';
import { ContentLibrary } from './types';

export const library: ContentLibrary = {
  authors: authors,
  articles: articles,
  pages: pages,
};
